export default {
  chatbubbleWrapper: {
    overflow: 'auto',
    fontWeight: '700',
    // maxWidth: 375,

  },
  chatbubble: {
    boxShadow: '0 0 6px rgba(0, 0, 0, .16)',
    backgroundColor: '#2b80b9',
    borderRadius: 5,
    marginTop: 1,
    marginRight: 'auto',
    marginBottom: 1,
    marginLeft: 'auto',
    maxWidth: 375,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 14,
    paddingRight: 14,
    // width: '-webkit-fit-content',
  },
  chatbubbleOrientationNormal: {
    float: 'right',
  },
  recipientChatbubble: {
    backgroundColor: 'white',
    color: 'black',

  },
  recipientChatbubbleOrientationNormal: {
    float: 'left',
  },
  p: {
    fontSize: 16,
    fontWeight: '700',
    maxWidth: 340,
    margin: 0
  },
  img: {
    fontSize: 16,
    fontWeight: '700',
    maxWidth: 340,
    margin: 0
  }
};
